import { render, staticRenderFns } from "./view-contact.vue?vue&type=template&id=5275f1c8&"
import script from "./view-contact.vue?vue&type=script&lang=js&"
export * from "./view-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports